<template>
  <div id="about" class="networkshops-about">
    <div class="public-container-mobile">
      <h2 v-html="title" class="vz-text-align-left" />
      <div class="networkshops-about-list">
        <div v-for="{ icon, text } in aboutItems">
          <vz-icon
            :url="icon"
            no-masked-icon
            variant="primary"
            size="33"
          />
          <span>{{ text }}</span>
        </div>
      </div>
    </div>
    <div class="networkshops-about-image">
      <div class="networkshops-about-image-title" v-html="data.cardTitle" />
      <div v-html="data.cardText" />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  isMarketplaces: {
    type: Boolean,
    default: false
  }
})

const title = computed(() => {
   return `Преимущества доставки Vozovoz ${props.isMarketplaces ? 'на Ozon,<br/> Wildberries и другие маркетплейсы' : '<br/>в сетевые магазины' }`
}) 

const data = {
  cardText: "Надежность каждого этапа доставки ваших товаров",
  cardTitle: "<strong>Комплексное решение</strong><p>для вашего бизнеса</p>",
  freeWarehousing: "Бесплатный простой машины в рамках «окна доставки»",
  insurance: "Страхование грузов",
  price: "Оптимальные тарифы",
  shipping: "Чёткий график отгрузки",
  cargo: "Проверка груза",
}

const aboutItems = computed(() => [
  {
    icon: '/svg/vz-coins.svg',
    text: data.price
  },
  {
    icon: '/svg/calendar.svg',
    text: data.shipping
  },
  {
    icon: '/svg/vz-box-success.svg',
    text: data.cargo
  },
  {
    icon: '/svg/vz-time-success.svg',
    text: data.freeWarehousing
  },
  {
    icon: '/svg/shield.svg',
    text: data.insurance
  },
])
</script>

<style scoped lang="scss">
.networkshops-about {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-top: 70px;
  margin-bottom: 28px;

  &-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
    font-size: $fs-16;
    line-height: 24px;
    font-weight: 700;

    > div {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  &-image {
    background-image: url("/images/pages/networkshops/banner1920.png");
    width: 610px;
    height: 340px;
    padding: 50px 250px 50px 50px;
    font-size: $fs-18;
    line-height: 1.5;

    &-title {
      font-size: $fs-24;
      font-weight: 900;
      margin-bottom: 15px;
      color: $primary;
      text-transform: uppercase;

      :deep(strong) {
        font-size: $fs-34;
        line-height: 40px;
      }
    }
  }
  @media screen and (max-width: $pub-md) {
    &-image {
      background-image: url("/images/pages/networkshops/banner1239.png");
      width: 513px;
      height: 320px;
      padding: 50px 200px 50px 40px;
      font-size: $fs-16;

      &-title {
        font-size: $fs-22;
        :deep(strong) {
          font-size: $fs-30;
          line-height: 38px;
        }
      }
    }
  }
  @media screen and (max-width: $pub-sm) {
    margin-top: 50px;
    &-image {
      background-image: url("/images/pages/networkshops/banner768.png");
      width: 363px;
      height: 300px;
      padding: 30px 120px 30px 30px;

      &-title {
        font-size: $fs-18;
        :deep(strong) {
          font-size: $fs-26;
        }
      }
    }
  }
  @media screen and (max-width: $pub-xs) {
    flex-direction: column;
    align-items: center;
    &-image {
      background-image: url("/images/pages/networkshops/banner320.png");
      width: 320px;
      height: 310px;
      padding: 30px 140px 30px 20px;
    }
  }
}
</style>
